import { memo } from "react";
import { Popup } from "components/popups/Popup";
import { Button } from "components/buttons/Button";
import { IAddToNicheConfirm } from "@/common/buses/popups/popup-types";
import { onCloseAddToNicheConfirm } from "@/components/popup-dispatcher/PopupDispatcher";
import { useMediaQuery } from "usehooks-ts";
import { TABLET_WIDTH } from "@/common/utils/device";
import "./AddToNicheConfirm.scss";

export const AddToNicheConfirm = memo((props: IAddToNicheConfirm) => {
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);

  const onContinue = () => {
    props.onContinue();
    onCloseAddToNicheConfirm();
  };

  return (
    <Popup
      title="Confirmation"
      isOpen={true}
      popupClass="AddToNicheConfirm"
      onClose={onCloseAddToNicheConfirm}
    >
      <div className="AddToNicheConfirm-Cnt">
        <h2 className="AddToNicheConfirm-Title">Are You Sure You Want to Skip?</h2>
        <p className="AddToNicheConfirm-Text">Adding your content to relevant niches helps it reach the right audience.</p>
        <div className="AddToNicheConfirm-Bottom">
          <Button size={isDesktop ? "l" : "m"} variant="secondary" onClick={onContinue}>Continue</Button>
          <Button size={isDesktop ? "l" : "m"} variant="primary" onClick={onCloseAddToNicheConfirm}>Add to Niches</Button>
        </div>
      </div>
    </Popup>
  );
});
